// extracted by mini-css-extract-plugin
export default {"aside":"Sidebar_aside__W6loT","scroll":"Sidebar_scroll__aMZd1","openMoreContent":"Sidebar_openMoreContent__cYF2z"};